import React, {useEffect} from 'react';
import FormSearch from './FormSearch'
import SarasMenu from '../../repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../repeater/menu/SarasFormMenuRow'
import SarasInput from '../../input/textField/SarasSearchInput'
import ActionButton from '../../input/buttons/button/SarasButton'
import * as fn from "../../../helper/uiFunctions";

const FormSearchButton = (props) => {
    const { formObject, action, autofocus, headerKey, tooltip, refreshMode,
        rowKey, inputClass, placeHolder, style, icon, filterKey,
        btnLabel, hideTxt, initCriteria, className, onSelect, execScanOnFocus, ...restProps } = props;
    const [inputVal, setInputVal] = React.useState('');
    const inputRef = React.useRef();

    const [docTypeId, setDocTypeId] = React.useState('');
    const [showSearch, setShowSearch] = React.useState(false);
    const [enableSelect, setEnableSelect] = React.useState(false);
    const [stayFocused, setStayFocused] = React.useState(0);

    const viewData = formObject.getFormRow(rowKey, headerKey);
    const infoData = formObject.getFormRow(null, headerKey + "_info");

    const inputHaveFocus = () =>{
        if (inputRef && document.activeElement === inputRef.current) {
            return true;
        }

        return false;
    }

    const onScan = (e) => {
        //if haveMultipleCapture is true then capture event only if this input have focus
        // console.log('scan event captured', e.detail.msg, inputRef);

        if(!e.detail.haveMultipleCapture || inputHaveFocus()){
            // console.log('device scan output', e.detail.msg);
            //workaround for after scan to make the input box empty
            setInputVal(' ');
            setInputVal('');
            if(autofocus) setStayFocused(stayFocused + 1);
            sendRequest(e.detail.msg, 0, 0, 1);
        }
    }

    let initialiseScanner = function() {
        // console.log("device scanner initialising in formsearch", scanner);

        // console.log("scanner listen");
        document.addEventListener('onScan', onScan, true);

        return function () {
            // console.log("device scanner callback removed", scanner);
            document.removeEventListener('onScan', onScan, true);
        }
    }

    useEffect(initialiseScanner, []);

    const onInputChange = (e, value) => {
        setInputVal(value)
    }

    const getSelectedRow = (value) => {
        if(value){
            // let selectedItem = viewData.rowValues[value];
            // if(!selectedItem)
            let selectedItem = viewData.rowValues[Object.keys(viewData.rowValues)[value]]
            return selectedItem;
        }

        return null;
    }

    const onButtonClick = (e) => {
        let buttonkey = (e.current || e.currentTarget).getAttribute('buttonkey');
        let selectedItem = viewData.rowValues[buttonkey];

        onItemSelect(selectedItem);
    }

    const onMenuSelect = (e, value) => {
        //get the value that was clicked
        let selectedItem = getSelectedRow(value);

        onItemSelect(selectedItem);
    }

    const onItemSelect = (selectedItem) => {
        //set doctype id
        let dtId = selectedItem.dataList.valLDT;
        let pathKey = selectedItem.dataList.pathKey;
        setDocTypeId(dtId);
        setShowSearch(false);

        // console.log("buttonkey", buttonkey, viewData.rowValues, dtId);
        // return;

        if (inputVal) {
            //if input is provided then directly fire quick add
            sendRequest(inputVal, dtId, 1, 0);
            setInputVal('');
            if(autofocus) setStayFocused(stayFocused + 1);
        }
        else {
            if (selectedItem.dataList.selectionMode === "editor") {
                //if selection mode is editor then fire new action id
                sendEditorRequest(dtId, pathKey);
            }
            else {
                //if selection mode is "not editor" then show search
                setShowSearch(true);
                setEnableSelect(selectedItem.dataList.enableSelect)
            }
        }
    }

    const onSaveClick = (selectedList) => {
        // console.log('selectedList', selectedList);
        setShowSearch(false);
        setDocTypeId('');
        sendRequest(selectedList.join(','), docTypeId, 0, 0);
    }

    const onCancelClick = () => {
        setShowSearch(false);
        setDocTypeId('');
    }

    const sendEditorRequest = (dtId, pathKey) => {
        const customAction = { ...action, containerKey: "popup" };
        customAction.actionId = "new";
        
        customAction.actionParam = { ...customAction.actionParam, 'quickAdd': 1, searchadd: '0', lidtId: dtId, dIds: '0' };

        if(pathKey){
            customAction.actionParam["pathKey"] = pathKey;
        }

        if (customAction.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
    }

    const sendRequest = (selectedList, dtId, quickAdd, isScan) => {
        //if the action config is to load editor after adding the selected item, 
        //then change the container key setting to load the editor view in popup
        const customAction = { ...action, containerKey: action.containerKey || ( action.loadEditorAfterAdd === 1 ? "popup" : "")};
        customAction.actionId = "refresh";
        customAction.refreshMode = refreshMode || "dep";

        customAction.actionParam =
        {
            ...customAction.actionParam, 'quickAdd': quickAdd || 0, "isScan" : isScan || 0,
            searchadd: '1', lidtId: dtId, dIds: selectedList
        };

        if(onSelect)onSelect(selectedList, dtId);

        if (customAction.actionId) formObject.onFormAction(customAction, rowKey, headerKey);
    }

    const renderSearchPopUp = () => {
        if (showSearch)
            return (
                <FormSearch enableSelect={enableSelect} onSaveClick={onSaveClick} onCancelClick={onCancelClick} docTypeId={docTypeId} initCriteria={initCriteria} />
            )
        else
            return (null)
    }

    const renderMenuTrigger = () => {
        //const MenuIcon = Icon[icon];
        return (
            <ActionButton 
            className="uiActionIconButton"
            starIcon={icon ? icon : 'add'}
            starIconClassName={'uiLink uiIcon'}
            onlyIcon={true}
            tooltip={"Search"}
            {...restProps}  />
        )
    }

    const onShouldHideOption = (key, row) => {
        let rowValue = row;
        
        if(!row && key) rowValue = getSelectedRow(key);

        // console.log("debug 3", rowValue, row, key);

        if(rowValue) return fn.compareNumber(rowValue.dataList.isHid, 1);

        return false;
    }

    const renderSearchButton = () => {
        let rowValues = viewData.rowValues;

        //hide full control
        if(hideControl === "1"){
            return null;
        }

        if (filterKey && false) {

            let btndata;

            btndata = rowValues[filterKey] || rowValues[Object.keys(rowValues)[filterKey]];

            if(btndata)
                return (
                    onShouldHideOption(null, btndata) ? null : <ActionButton tooltip={tooltip} onClick={onButtonClick} buttonkey={btndata.key} text={btnLabel || btndata.dataList.label} ksc={btndata.dataList.shortcut} className="uiActionButton" />
                )

            return null;
        }
        else {
            return (
                <SarasMenu menuTrigger={renderMenuTrigger()}
                dataList={Object.values(rowValues)} hideTriggerIfNoOptions={1} onShouldHideOption={onShouldHideOption}
                menuItem={SarasFormMenuRow} onSelection={onMenuSelect} />
            )
        }
    }

    const renderTextBox = () => {
        if(hideTxt || hideControl === "1") return null;

        if (Object.keys(viewData.rowValues).length > 0) {
            return (
                <SarasInput className={inputClass} stayFocused={stayFocused} autofocus={autofocus} 
                inputRef={inputRef}
                actionButton={renderSearchButton()}
                onChange={onInputChange} type='search' value={inputVal} placeholder={placeHolder || 'Barcode / Id...'} />
            )
        }
    }

    // const renderScanner = () => {
    //     if(scanner && !scanner.isDeviceConnected){
    //         return (<button className='uiActionButtonBlue' 
    //         onClick={() => scanner.requestDevicePermission()}><SarasTrans value = "Connect Scanner"/></button>);
    //     }

    //     return null;
    // }

    if (!viewData)
        return (null);

    // console.log("debug", infoData, infoData.rowValues.hideControl);

    const hideControl = (infoData && infoData.rowValues.hideControl.val) || "0";

    return (
        <>
            {renderTextBox()}
            {/* {renderSearchButton()} */}
            {renderSearchPopUp()}
            {/* {renderScanner()} */}
        </>
    )
}

export default FormSearchButton